import { lazy } from "react";
import { INVENTORY } from "app_constants";

import { ICON_TYPE } from "components/icons/icon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import type { ISectionProps } from "types/navigation";

const INVENTORY_SECTION: ISectionProps = {
  feature: "Inventory",
  app: INVENTORY,
  icon: ICON_TYPE.INVENTORY,
  path: "/inventory",
  level: ["store", "brand"],
  dateSupport: DateRangeSupport.NONE,
  requiredApp: "inventory",
  requiredSessions: ["inventory"],
  component: lazy(() => import("containers/chrome/upsell_container")),
  subSections: [
    {
      feature: "Dashboard",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/dashboard",
      legacyPath: () => "/",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Orders",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/orders",
      legacyPath: () => "/orders",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Purchase Orders",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/purchase_orders",
      legacyPath: () => "/sent-orders",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Inventory",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/inventory",
      legacyPath: () => "/inventory",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Suppliers",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/suppliers",
      legacyPath: () => "/suppliers",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Menu",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/menu",
      legacyPath: () => "/bom/",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Reports",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/reports",
      legacyPath: () => "/reports",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Settings",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/settings",
      legacyPath: () => "/settings",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
    {
      feature: "Help",
      app: INVENTORY,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/inventory/help",
      legacyPath: () => "/faq",
      dateSupport: DateRangeSupport.NONE,
      requiredSessions: ["inventory"],
    },
  ],
};

export default INVENTORY_SECTION;
